import { Box, Card, Divider, Grid, Typography } from "@mui/material"
import { useParams } from "react-router-dom";
import CreateEditWalletForm from "./create-edit.form";
import GoBackButton from "../../components/go-back-button";

export default function CreateOrEditWallet() {
    const params = useParams();
    const editMode = params.walletid != null ? true : false
    return (
        <>
            <Box mt={3} mb={1}>
                <Box mb={1.5}>
                    <GoBackButton />
                </Box>
                <Grid container alignItems="center" spacing={1}>
                    <Grid>
                        <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main', letterSpacing: 1 }}>
                            {editMode === false ? "Criar Carteira" : "Editar Carteira"}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
                <Box mt={2}>
                    <Card sx={{ border: '1px solid rgba(255,215,0,0.15)' }}>
                        <CreateEditWalletForm editMode={editMode} walletId={params.walletid} />
                    </Card>
                </Box>
            </Box>
        </>
    )
}